import { ArrowUpRight } from "lucide-react";
import { Seo, Eyebrow, CTAButton } from "@/components/site/primitives";
import { Reveal, Stagger, Item } from "@/components/site/motion";
import { PageHero, Section } from "@/components/site/pageparts";

const FEATURES = [
  { t: "40+ connectors", d: "Postgres, Snowflake, BigQuery, Databricks, Redshift, MySQL, MongoDB, S3 and more — sandboxed, read-only sync." },
  { t: "Natural language to governed SQL", d: "Ask in plain English; Sema plans against a typed semantic graph and shows the SQL it ran and the nodes it traversed." },
  { t: "Signed evidence packs", d: "Every answer is bundled with its question, SQL and lineage, then cryptographically signed — tampering is detectable." },
  { t: "RBAC & column masking", d: "Viewer, analyst, admin, owner — enforced in code. Restricted columns are refused or masked at plan time." },
  { t: "DPDP-aligned audit logs", d: "Append-only, exportable records of every mutation and every answer — the evidence pack for any decision." },
  { t: "Governed by default", d: "Row-level access, query logging and signed answers are on at install. Turning governance off is a deliberate choice." },
];

export default function Semalayer() {
  return (
    <div data-testid="semalayer-page">
      <Seo title="Semalayer — the governed semantic layer" description="Sema is a governed semantic layer: ask your data anything, trust the answer." />
      <PageHero
        eyebrow="Product · Sema"
        title="A governed semantic layer: ask your data anything, trust the answer."
        lead="Sema connects your warehouse, infers what the data means, and answers business questions in plain English — with audit-grade governance from day one."
      >
        <CTAButton href="https://semalayer.com" external variant="solid">
          Visit semalayer.com <ArrowUpRight className="h-4 w-4" />
        </CTAButton>
      </PageHero>

      <Section>
        <Stagger className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f) => (
            <Item key={f.t} className="bg-ink p-7">
              <h3 className="font-serif text-lg text-bone">{f.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-mist">{f.d}</p>
            </Item>
          ))}
        </Stagger>
      </Section>

      <Section className="border-t border-white/10">
        <Reveal className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <p className="max-w-xl text-[15px] leading-relaxed text-mist">
            Sema is a separate product in the DataFrontier family. Explore connectors, governance and pricing on its own
            site.
          </p>
          <CTAButton href="https://semalayer.com" external variant="outline">
            Explore Sema <ArrowUpRight className="h-4 w-4" />
          </CTAButton>
        </Reveal>
      </Section>
    </div>
  );
}
